import Home from './pages/home';
import LoadingScreen from './components/loading-screen';

function App() {
    return (
        <div className="App">
            <LoadingScreen />
            <Home />
        </div>
    );
}

export default App;
